import { ServiceStateEnums } from "src/app/enum/service-state-enums";
import { CostCenterModel } from "../archive/cost-center.model";
import { InvoicingCutoffModel } from "../invoicing/invoicing-cutoff.model";
import { OrderModel } from "../preliminaries/order.model";

export class ServiceModel {
  serviceId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterNumber: number | null = null;
  costCenterId: number = 0;
  costCenter: CostCenterModel = new CostCenterModel();
  dateService: Date = new Date();
  serviceStateId: number = ServiceStateEnums.abierto;
  swBlock: boolean = false;
  swInvoiceSeparately: boolean = false;
  isTypeCutoffMovement: boolean = true;
  invoicingCutoffId: number | null = null;
  invoicingCutoff: InvoicingCutoffModel | null = null;
  observation: string | null = null;
  swOrder: boolean = false;
  orderId: number | null = null;
  order: OrderModel | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}